
import React from 'react';
import { Award } from 'lucide-react';

interface Achievement {
  id: string;
  title: string;
  completedDate: Date;
}

interface AchievementsListProps {
  achievements: Achievement[];
}

const AchievementsList: React.FC<AchievementsListProps> = ({ achievements }) => {
  // Format date to a readable string
  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    }).format(date);
  };

  return (
    <div className="space-y-4">
      {achievements.map(achievement => (
        <div key={achievement.id} className="border rounded-lg p-4 flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Award className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="font-medium">{achievement.title}</h3>
            <p className="text-xs text-muted-foreground">Completed • {formatDate(achievement.completedDate)}</p>
          </div>
        </div>
      ))}
      
      {achievements.length === 0 && (
        <div className="text-center py-8">
          <p className="text-muted-foreground">Complete courses to earn achievements.</p>
        </div>
      )}
    </div>
  );
};

export default AchievementsList;
